import { render } from "./EnterTelephone.vue?vue&type=template&id=bd9835f2"
import script from "./EnterTelephone.vue?vue&type=script&lang=js"
export * from "./EnterTelephone.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__